import React from "react";
import {VehicleReadings} from "../components/VehicleReadings";
import {FuelType} from "../useKeylessReturn";

export default function FuelLevelAndKms(
  {
    fuelType,
    fuelLevel,
    setFuelLevel,
    kms,
    setKms,
    t,
  }
) {
  return (<div
    style={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      gap: "1rem",
      padding: "1rem 0",
    }}
  >
    <p style={{fontSize: "1.1rem", margin: 0, lineHeight: "1.3"}}>
      <b style={{fontWeight: "800"}}>
        {fuelType === FuelType.ELECTRIC
          ? t("keylessReturnChargeConfirm")
          : t("keylessReturnFuelConfirm")}
      </b>
    </p>

    <VehicleReadings
      fuelType={fuelType}
      fuelLevel={fuelLevel}
      setFuelLevel={setFuelLevel}
      kms={kms}
      setKms={setKms}
      fuelNote={
        <p style={{fontSize: "1rem", margin: 0, lineHeight: "1.3"}}>
          {t("keylessReturnFuelFee")}
        </p>
      }
      t={t}
    />

  </div>)
}
